function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { _translate } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import Collector from "../../../../services/collector";

/**
 * Fonction utilitaire
 */
var useUtils = function useUtils() {
  var _currentQuestion$publ;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher;
  var currentQuestion = collector.currentQuestion,
    currentOrder = collector.currentOrder,
    responses = collector.responses,
    historic = collector.historic,
    diagId = collector.diagId;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    responsesCategorized = _useState2[0],
    setResponsesCategorized = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    mode = _useState4[0],
    setMode = _useState4[1];
  var order = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.order;
  order = order ? order.split(',').map(function (el) {
    return el.trim();
  }) : null;

  /**
   * Permet de trier les catégories par rapport aux parents
   *
   * @param {array} categories
   * @param {object} list
   */
  var _sortCategories = function sortCategories(categories, list) {
    // Nous allons ranger les catégories dans leur parent.
    categories.forEach(function (category) {
      if (!category) {
        return;
      }
      if (category.parent) {
        if (!list[category.parent.name]) {
          list[category.parent.name] = category.parent;
        }
        if (!list[category.parent.name].child) {
          list[category.parent.name].child = [];
        }
        var isFound = false;
        list[category.parent.name].child.forEach(function (child) {
          if (child && child.name === category.name) {
            isFound = true;
          }
        });
        if (!isFound) {
          list[category.parent.name].child.push(category);
        }
        _sortCategories([category.parent], list);
      } else {
        if (!list[category.name]) {
          list[category.name] = category;
        }
      }
    });
  };

  /**
   * Les réponses ont leur catégories à l'intérieur,
   * mais on possède aussi une liste de toutes les catégories possibles.
   * Donc on va devoir mixer les deux pour optimiser la mise en place des différentes catégories
   * et de leurs réponses.
   */
  var sortResponsesByCategory = function sortResponsesByCategory() {
    var categories = {};
    var expectedResponses = currentQuestion.expectedResponses;
    expectedResponses.forEach(function (response) {
      if (!response || !response.categories) {
        return;
      }
      response.categories.forEach(function (category) {
        if (!category.name) {
          return;
        }
        var categoryName = category.name.trim();
        if (!categories[categoryName]) {
          categories[categoryName] = category;
        }
        if (!categories[categoryName].responses) {
          categories[categoryName].responses = [];
        }
        var isFound = false;
        categories[categoryName].responses.forEach(function (resp) {
          if (!resp) {
            return;
          }
          if (resp.alias === response.alias) {
            isFound = true;
          }
        });
        if (!isFound) {
          categories[categoryName].responses.push(response);
        }
      });
    });
    var groupCategories = {};
    _sortCategories(Object.values(categories), groupCategories);
    groupCategories = Object.values(groupCategories);
    var sortedCategories = groupCategories.map(function (category) {
      var found = false;
      currentQuestion.categories.forEach(function (q_category) {
        if (q_category.name === category.name) {
          found = true;
        }
      });
      if (found && category.child && category.child.length > 0) {
        category.child = category.child.map(function (childCategory) {
          var isFoundChild;
          currentQuestion.categories.forEach(function (q_category) {
            if (childCategory && q_category.name === childCategory.name) {
              isFoundChild = true;
            }
          });
          return isFoundChild ? childCategory : null;
        });
      }
      return found ? category : null;
    });
    if (order) {
      var structuredElements = order.map(function (alias) {
        var foundElement = null;
        sortedCategories.forEach(function (element) {
          if (!foundElement && element && element.name === alias) {
            foundElement = element;
          }
        });
        return foundElement;
      });
      sortedCategories = structuredElements;
    }
    setResponsesCategorized(sortedCategories);
  };
  var getDefault = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var responsesFromHistoric, historicResponse, question, _historic$list, _historic$list2, currHistoricOrder, apiResponse, currentAlias, i, _question$expectedRes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
            historicResponse = responsesFromHistoric === null || responsesFromHistoric === void 0 ? void 0 : responsesFromHistoric.responses;
            if (historicResponse) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            question = currentQuestion;
            if (!(historic !== null && historic !== void 0 && historic.list)) {
              _context.next = 18;
              break;
            }
            currHistoricOrder = historic.current ? historic === null || historic === void 0 || (_historic$list = historic.list[historic.current.index - 1]) === null || _historic$list === void 0 ? void 0 : _historic$list.order : (_historic$list2 = historic.list[historic.list.length - 1]) === null || _historic$list2 === void 0 ? void 0 : _historic$list2.order;
            _context.prev = 7;
            _context.next = 10;
            return Collector.getNextQuestion(diagId, currHistoricOrder || '0_b.-1_q', responses);
          case 10:
            apiResponse = _context.sent;
            question = JSON.parse(apiResponse.data.question);
            dispatcher({
              type: 'currentQuestion',
              value: JSON.parse(apiResponse.data.question)
            });
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](7);
            console.error('QUESTION', _context.t0);
          case 18:
            currentAlias = historicResponse["".concat(currentQuestion.alias, "_mode")];
            if (currentAlias) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("return");
          case 21:
            if (!question.expectedResponses) {
              _context.next = 30;
              break;
            }
            i = 0;
          case 23:
            if (!(i < question.expectedResponses.length)) {
              _context.next = 30;
              break;
            }
            if (!(((_question$expectedRes = question.expectedResponses[i]) === null || _question$expectedRes === void 0 ? void 0 : _question$expectedRes.alias) === currentAlias)) {
              _context.next = 27;
              break;
            }
            setMode(question.expectedResponses[i]);
            return _context.abrupt("break", 30);
          case 27:
            i++;
            _context.next = 23;
            break;
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 15]]);
    }));
    return function getDefault() {
      return _ref.apply(this, arguments);
    };
  }();
  var init = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getDefault();
          case 2:
            _context2.next = 4;
            return sortResponsesByCategory();
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function init() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    init();
  }, []);
  return {
    categories: responsesCategorized,
    defaultMode: mode
  };
};
export default useUtils;